import React, { useMemo, useState } from 'react';
import { Button } from 'antd';
import styled from 'styled-components';

import { FlexContainer } from 'components/Layout/common';
import { cdnURL } from 'utils/helpers';

import { useBDOPermissions } from '../../../utils';
import { CardType, getCardStatus } from '../filters/filterOptions';
import ActivateCardModal from './ActivateCardModal';
import BlockCardModal from './BlockCardModal';
import ReplaceCardModal from './ReplaceCardModal';

type Tier = '01' | '03' | '04';

export interface ICustomerCard {
  type: CardType['label'];
  status: 'A' | 'B' | 'F' | 'I' | 'N';
  cardProps: { brc: string; tier: Tier; sequence: string; activity_description: string };
  refetchCustomer: () => void;
  isPool?: boolean;
}

const BDOCustomerCard = ({
  type,
  status = 'N',
  cardProps,
  refetchCustomer,
  isPool
}: ICustomerCard) => {
  const [modalType, setModalType] = useState(null);
  const hideModal = () => setModalType(null);
  const cardStatus = getCardStatus(status);

  const { canPerformCardActions } = useBDOPermissions();

  const virtualcardTxtColor = useMemo(() => {
    if (isPool) {
      if (cardProps.tier === '01') return '#fff';
      if (cardProps.tier === '03') return '#fff';
      if (cardProps.tier === '04') return '#000';
      return '#000';
    }
  }, [cardProps.tier, isPool]);
  return (
    <CardContainer
      style={{
        opacity: type ? '100%' : '0%',
        backgroundImage: `url(${getBackgroundImageURL(type)})`
      }}
    >
      {isPool ? (
        <div
          style={{
            position: 'absolute',
            fontSize: '20px',
            fontWeight: '700',
            top: '65px',
            left: '19px',
            color: virtualcardTxtColor
          }}
        >
          VIRTUAL CARD
        </div>
      ) : null}

      <ActionContainer>
        <div
          style={{
            fontSize: '20px',
            fontWeight: '700',
            marginBottom: '14px',
            color: cardStatus?.color
          }}
        >
          {cardStatus?.label.toUpperCase()}
        </div>
        {canPerformCardActions && (
          <FlexContainer justifyContent="space-between" style={{ gap: '8px' }}>
            {cardStatus?.actions.map(action => (
              <Button
                key={action}
                onClick={() => setModalType(action)}
                style={{
                  flexGrow: '1',
                  display:
                    cardProps['activity_description'] === 'Card Replacement' ? 'none' : 'block'
                }}
              >
                {action}
              </Button>
            ))}
          </FlexContainer>
        )}
        <ReplaceCardModal
          open={modalType && modalType === 'Replace'}
          closeModal={hideModal}
          cardProps={cardProps}
          onCancel={hideModal}
          refetchCustomer={refetchCustomer}
        />
        <BlockCardModal
          open={modalType && modalType === 'Block'}
          closeModal={hideModal}
          cardProps={cardProps}
          onCancel={hideModal}
          refetchCustomer={refetchCustomer}
        />
        <ActivateCardModal
          open={modalType && modalType === 'Activate'}
          closeModal={hideModal}
          cardProps={cardProps}
          onCancel={hideModal}
          refetchCustomer={refetchCustomer}
        />
      </ActionContainer>
    </CardContainer>
  );
};

export default BDOCustomerCard;

const getBackgroundImageURL = (type: string) => {
  switch (type) {
    case 'Diamond':
      return cdnURL('bdo/cards/diamond_card.png');
    case 'Sapphire':
      return cdnURL('bdo/cards/sapphire_card.png');
    case 'Emerald':
      return cdnURL('bdo/cards/emerald_card.png');
    default:
      break;
  }
};

const CardContainer = styled.div`
  border-radius: 8px;
  background-repeat: no-repeat;
  background-size: 344px;
  width: 344px;
  height: 219px;
  padding: 104px 0 0 0;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  transition: opacity 0.3s ease-in;
`;

const ActionContainer = styled.div`
  width: 100%;
  background-color: white;
  max-height: 115px;
  padding: 18px;
  border-radius: 0px 0px 8px 8px;
`;
